<template>
  <div
    :class="[
      'navWrap',
      isLogin && !isNoneMenu ? 'isLogin' : '',
    ]">
    <b-navbar
      class="navBar px-0"
      align="left"
      fill="true">
      <b-navbar-brand class="noLink" href="#">
        <img src="../assets/img/group-logo.gif">
      </b-navbar-brand>
      <b-navbar-brand
        :class="isNoneMenu?'noLink':''"
        href="#"
        @click="goZaidan">
        <img src="../assets/img/group-name.png">
      </b-navbar-brand>
<!--       <b-navbar-brand
        v-if="page==='uni'"
        class="manual-wrap"
        @click="downloadManual('uni')">
        <b-link>操作マニュアル</b-link>
      </b-navbar-brand> -->
     <b-navbar-brand
        href="#"
        class="noLink systemLogo bold">
        <img src="../assets/img/sdgs_logo.png">
      </b-navbar-brand>
    </b-navbar>
    <div class="band"></div>
    <div class="menuWrap" v-if="isLogin && !isNoneMenu">
      <cms-header
        v-if="page==='cms'"
        :menuName.sync="nowMenuName"
        @kickLogout="logout"/>
      <gas-header
        v-if="page==='gas'"
        :menuName.sync="nowMenuName"
        @kickLogout="logout"/>
      <uni-header
        v-if="page==='uni'"
        :menuName.sync="nowMenuName"
        @kickLogout="logout"/>
    </div>
  </div>
</template>

<script>
import CmsHeader from '@/components/cms/Header.vue';
import GasHeader from '@/components/gas/Header.vue';
import UniHeader from '@/components/university/Header.vue';
import CONST_SETTING from '@/constants/pageGroupSetting';
import download from '@/modules/download';
import api from '@/modules/api';

export default {
  name: 'Header',
  components: {
    'cms-header': CmsHeader,
    'gas-header': GasHeader,
    'uni-header': UniHeader,
  },
  props: {
  },
  data() {
    return {
    };
  },
  methods: {
    async logout() {
      const routeName = this.page === 'cms' || this.page === 'uni' ? 'cmsLogin' : 'gasLogin';
      // next(false)の場合は、そのfalseをキャッチして、ログアウト処理を走らせない
      const result = await this.$router.push({ name: routeName })
        .catch((error) => {
          return error;
        });
      if (result) {
        this.$store.dispatch('auth/logout');
      }
    },
    goTop() {
      if (this.isInit || this.isNoneMenu) {
        return;
      }
      let routeName = '';
      if (!this.isLogin) {
        routeName = this.page === 'cms' || this.page === 'uni' ? 'cmsLogin' : 'gasLogin';
      } else {
        routeName = this.page === 'cms' || this.page === 'uni' ? 'cmsTop' : 'gasTop';
      }
      this.$router.push({ name: routeName });
    },
    goZaidan() {
      if (this.isNoneMenu) {
        return;
      }
      window.open('http://www.kddi-foundation.or.jp/');
    },
    async downloadManual(type) {
      const url = CONST_SETTING.MANUAL_URL[type];
      if (!url) {
        return;
      }
      this.$store.dispatch('page/onWaiting');
      const response = await api.send(url, {}, true)
        .catch((err) => {
          console.error(err);
        });
      this.$store.dispatch('page/offWaiting');
      if (!response) {
        await this.alert('ファイルのダウンロードに失敗しました。');
        return;
      }
      download.blob(response.data, '操作マニュアル.pdf');
    },
  },
  computed: {
    page() {
      return this.$store.state.page.view;
    },
    nowMenuName() {
      return this.$route.meta.menu;
    },
    isNoneMenu() {
      return this.$route.name === 'gasApplicationPrint';
    },
    isLogin() {
      return this.$store.state.auth.login_id !== null;
    },
    isInit() {
      const isTop = this.$route.name === 'gasTop' || this.$route.name === 'cmsTop';
      const isLogin = this.$route.name === 'gasLogin' || this.$route.name === 'cmsLogin';
      return isTop || isLogin;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .manual-wrap{
    font-size: 1.1rem;
  }
  .navWrap {
    width: 100%;
    /* 本家ではmax-width: 950pxであたってたが、全部に当てると大画面でも余白ができない */
    background-position: -2028px 0;
    color: #0E0D69 !important;
    min-width: 1280px;
    height: 77px;
  }
  .navWrap.isLogin {
    height: 117px;
  }

  .navBar {
    /* ここにバックグラウンドカラーを当ててもビルドした時に反映されない */
    min-width: 1280px;
    max-width: 1280px;
    height: 72px;
    margin: 0 auto;
  }

  .menuWrap {
    height: 40px;
    background-color: rgba(14, 13, 105, 0.1);
    margin-left: auto;
  }

  .menuLabel {
    height: 40px;
    min-width: 1280px;
    max-width: 1280px;
    margin: 0 auto;
  }

  .systemLogo {
    position: absolute;
    right: 0;
    top: 0;
    color: #0E0D69 !important;
  }

  .noLink:hover {
    cursor: default;
  }

  .band {
    height: 5px;
    width: 100%;
    background-color: #0E0D69;
  }
</style>
